import VistaTransporte from "@/views/Transporte.vue";

const transporte = {
  path: "/app/transporte",
  name: "transporte",
  component: VistaTransporte
};

export default transporte;
